const SHOW_ALERT = 'SHOW_ALERT';


const _alert = (show, state, message, dismissible = true, persistence = false, closeOnClick = true, readClicked=null) => ({
    type: SHOW_ALERT,
    payload: {
        show,
        state,
        message,
        dismissible,
        persistence,
        closeOnClick,
	    readClicked
    }
});

export {
    SHOW_ALERT,
    _alert
}